var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",class:_vm.buttonClass},_vm.$listeners),[_c('span',{staticClass:"button__content"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }